import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

import { useGlobalContext } from '../../AppContext';
import { ENSTableDataProps, NFTTableDataProps } from '../../constants/interfaces';
import { networks } from '../../utils/constants';
import { timeConverter } from '../../utils/utils';
import { BigButton } from '../../components/BigButton';
import { BigMenu } from '../../components/BigMenu';
import { Card } from '../../components/Card';
import { Dropdown } from '../../components/Dropdown';
import { Loading } from '../../components/Loading';
import { NFT } from '../../components/NFT';

import './NFTAndENS.scss';

// 0xF5FFF32CF83A1A614e15F25Ce55B0c0A6b5F8F2c

export const NFTAndENS = () => {
  const [theme, setTheme] = useState('light');

  useEffect(() => {
    const handleThemeChange = () => {
      const newTheme = document.body.classList.contains('dark') ? 'light' : 'dark';
      setTheme(newTheme);
    };

    handleThemeChange();

    const observer = new MutationObserver(handleThemeChange);
    const config = { attributes: true, attributeFilter: ['class'] };
    observer.observe(document.body, config);

    return () => {
      observer.disconnect();
    };
  }, []);
  const { isMobile, config, wallets, nft, tokenDetails } = useGlobalContext();
  const history = useLocation().state as { type: string };
  const [selectedType, setSelectedType] = useState<string>('nft');
  const [viewType, setViewType] = useState<string>('grid');

  const [showTableNft, setShowTableNft] = useState<JSX.Element>(<></>);
  const [showTableNftGrid, setShowTableNftGrid] = useState<JSX.Element>(<></>);
  const [showTableNftList, setShowTableNftList] = useState<JSX.Element>(<></>);
  const [showTableEns, setShowTableEns] = useState<JSX.Element>(<></>);
  const [showTableEnsGrid, setShowTableEnsGrid] = useState<JSX.Element>(<></>);
  const [showTableEnsList, setShowTableEnsList] = useState<JSX.Element>(<></>);
  const [tableDataNft, setTableDataNft] = useState<NFTTableDataProps[]>([]);
  const [tableDataEns, setTableDataEns] = useState<ENSTableDataProps[]>([]);
  const [loaded, setLoaded] = useState(false);
  const [loading, setLoading] = useState(true);
  const [tableWalletFilter, setTableWalletFilter] = useState<string>();
  const [networkFilter, setNetworkFilter] = useState<string[]>([]);
  const [ensData, setEnsData] = useState<any>();
  const [nftData, setNftData] = useState<any>();

  useEffect(() => {
    if (config) {
      if (!loaded) fetchList();
    } else {
      setLoading(true);
    }
  }, [config]);

  useEffect(() => {
    try {
      if (history.type) {
        setSelectedType(history.type);
      }
    } catch (e) {
      console.log(e.message);
    }
  }, [history]);
  useEffect(() => {
    const tmpData: ENSTableDataProps[] = new Array();

    if (ensData) {
      Object.keys(ensData).forEach((value: string, index: number) => {
        if (ensData[index].metadata) {
          try {
            const metaData = ensData[index].metadata;
            if (typeof metaData === 'object' && metaData !== null) {
              ensData[index].metadata = { ...metaData };
            } else {
              ensData[index].metadata = { ...JSON.parse(metaData) };
            }
            tmpData.push({
              url: ensData[index].metadata && ensData[index].metadata.url,
              domain: ensData[index].metadata && ensData[index].metadata.name,
              createDate: timeConverter(ensData[index].metadata.attributes[2].value / 1000),
              registerDate: timeConverter(ensData[index].metadata.attributes[2].value / 1000),
              expireDate: timeConverter(ensData[index].metadata.attributes[3].value / 1000),
              wallet: ensData[index].wallet,
              contract: ensData[index].token_address,
              network: networks['erc20'].name,
              networkKey: ensData[index].network,
              name: (ensData[index].metadata && ensData[index].metadata.name) || '-',
              link:
                ensData[index].metadata &&
                (ensData[index].metadata.image_url || ensData[index].metadata.image),
              id: parseInt(ensData[index].token_id).toString(),
            });
          } catch (e) {
            console.log(e);
          }
        }
      });

      setTableDataEns(tmpData);
    }
  }, [ensData]);

  useEffect(() => {
    const tmpData: NFTTableDataProps[] = new Array();
    const tmpNetworks: string[] = [];
    if (nftData) {
      Object.keys(nftData).forEach(async (value: string, index: number) => {
        nftData[index].network =
          nftData[index].chainId === 1
            ? 'erc20'
            : nftData[index].chainId === 137
            ? 'polygon'
            : nftData[index].chainId === 56
            ? 'bep20'
            : nftData[index].chainId === 1284
            ? 'moonbeam'
            : nftData[index].chainId === 1285
            ? 'moonriver'
            : nftData[index].chainId === 43114
            ? 'avalanche'
            : 'erc20';
        if (config.globalNetworks[nftData[index].network]) {
          try {
            const metaData =
              nftData[index].metadata && typeof nftData[index].metadata === 'object'
                ? nftData[index].metadata
                : nftData[index].metadata
                ? JSON.parse(nftData[index].metadata)
                : [];

            tmpData.push({
              ntw: nftData[index].network,
              contract: nftData[index].token_address,
              network: networks[nftData[index].network].name,
              networkKey: nftData[index].network,
              logo: networks[nftData[index].network].icon,
              wallet: nftData[index].wallet,
              name: (metaData && metaData.name) || nftData[index].name || '-',
              symbol: nftData[index].symbol || '-',
              amount: nftData[index].amount,
              link: metaData && (metaData.image_url || metaData.image),
              id: parseInt(nftData[index].token_id).toString(),
            });
            tmpNetworks.push(nftData[index].network);
          } catch (e) {
            console.log(e);
          }
        }
      });

      setTableDataNft(Object.values(tmpData));
      setNetworkFilter(Object.values(tmpNetworks));
    }
  }, [nftData]);

  const fetchList = async (): Promise<void> => {
    const nftDataTmp: any[] = [];
    const ensDataTmp: any[] = [];

    if (nft) {
      Object.keys(nft).filter((key: any) => {
        Object.keys(nft[key]).filter((index: any) => {
          Object.keys(nft[key][index]).filter((index2: any) => {
            nft[key][index][index2].wallet = key;

            if (index === 'erc20') nft[key][index][index2].chainId = 1;
            else if (index === 'bep20') nft[key][index][index2].chainId = 56;
            else if (index === 'polygon') nft[key][index][index2].chainId = 137;
            else if (index === 'avalanche') nft[key][index][index2].chainId = 43114;
            else if (index === 'moonbeam') nft[key][index][index2].chainId = 1284;
            else if (index === 'moonriver') nft[key][index][index2].chainId = 1285;

            if (
              nft[key][index][index2].token_address !== '0x57f1887a8bf19b14fc0df6fd9b2acc9af147ea85'
            ) {
              nftDataTmp.push(nft[key][index][index2]);
            } else {
              ensDataTmp.push(nft[key][index][index2]);
            }
          });
        });
      });
    }
    setEnsData(ensDataTmp);
    setNftData(nftDataTmp);

    setLoaded(true);
    setLoading(false);
  };

  const renderShowTableNft = (data: any): void => {
    data.sort((a: any) => {
      return tokenDetails[a.contract] && tokenDetails[a.contract].price ? -1 : 1;
    });
    setShowTableNft(
      <div className="nft-list inline-border-container">
        <svg
          width="0"
          height="0"
          viewBox="0 0 279 412"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <clipPath id="myClip">
            <path
              d="M16.4143 106.869V366.054L45.3183 394.943H114.532L131.575 412H258.834L276.767 394.077V309.964L261.523 294.728V198.956L279 181.466V39.4878H217.528L193.546 15.5177H71.2299L53.5363 0L0 53.5102V88.2517L16.4143 106.869Z"
              fill="#394455"
            />
          </clipPath>
        </svg>
        {data.map((item: any, index: number) => {
          return (
            <NFT
              key={index}
              name={item.name}
              network={item.network}
              id={item.id}
              price={tokenDetails[item.contract] ? tokenDetails[item.contract].price : ''}
              wallet={wallets && wallets.length > 1 ? item.wallet : ''}
              image={
                (item.link && item.link.replace('ipfs://', 'https://ipfs.io/ipfs/')) ||
                '/images/empty-nft.png'
              }
              n={
                item.network === 'Ethereum'
                  ? 'ethereum'
                  : item.network === 'Polygon'
                  ? 'matic'
                  : item.network === 'Avalanche'
                  ? 'avalanche'
                  : 'ethereum'
              }
              contract={item.contract}
            />
          );
        })}
      </div>,
    );
    if (isMobile) {
      setShowTableNftGrid(
        <div className="nft-list-grid">
          {data.map((item: any, index: number) => {
            return (
              <div
                key={index}
                onClick={() => {
                  setShowTableNftList(
                    <div className="nft-list inline-border-container">
                      <svg
                        width="0"
                        height="0"
                        viewBox="0 0 279 412"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <clipPath id="myClip">
                          <path
                            d="M16.4143 106.869V366.054L45.3183 394.943H114.532L131.575 412H258.834L276.767 394.077V309.964L261.523 294.728V198.956L279 181.466V39.4878H217.528L193.546 15.5177H71.2299L53.5363 0L0 53.5102V88.2517L16.4143 106.869Z"
                            fill="#394455"
                          />
                        </clipPath>
                      </svg>
                      <NFT
                        key={index}
                        name={item.name}
                        network={item.network}
                        id={item.id}
                        price={tokenDetails[item.contract] ? tokenDetails[item.contract].price : ''}
                        wallet={item.wallet}
                        image={
                          (item.link && item.link.replace('ipfs://', 'https://ipfs.io/ipfs/')) ||
                          '/images/empty-nft.png'
                        }
                        n={
                          item.network === 'Ethereum'
                            ? 'ethereum'
                            : item.network === 'Polygon'
                            ? 'matic'
                            : item.network === 'Avalanche'
                            ? 'avalanche'
                            : 'ethereum'
                        }
                        contract={item.contract}
                      />
                    </div>,
                  );
                  setViewType('list');
                }}
              >
                <svg width="0" height="0" viewBox="0 0 0 0">
                  <clipPath id="myClip2">
                    <path d="M 0.521 0 L 0.521 120 L 120.521 120 L 120.521 25.972 L 88.597 25.972 L 69.717 0 L 0.521 0 Z" />
                  </clipPath>
                </svg>
                <span>
                  <img src={`/icons/eye-${theme}.svg`} alt="" />
                </span>
                <img
                  className="nft-grid-image"
                  src={
                    (item.link && item.link.replace('ipfs://', 'https://ipfs.io/ipfs/')) ||
                    '/images/empty-nft.png'
                  }
                  alt=""
                />
              </div>
            );
          })}
        </div>,
      );
    }
  };

  const renderShowTableEns = (data: any): void => {
    setShowTableEns(
      <div className="nft-list inline-border-container">
        <svg
          width="0"
          height="0"
          viewBox="0 0 279 412"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <clipPath id="myClip">
            <path
              d="M16.4143 106.869V366.054L45.3183 394.943H114.532L131.575 412H258.834L276.767 394.077V309.964L261.523 294.728V198.956L279 181.466V39.4878H217.528L193.546 15.5177H71.2299L53.5363 0L0 53.5102V88.2517L16.4143 106.869Z"
              fill="#394455"
            />
          </clipPath>
        </svg>

        {data.map((item: any, index: number) => {
          return (
            <NFT
              key={index}
              name={item.name}
              network={'Expiry'}
              id={item.id}
              wallet={item.expireDate}
              price={tokenDetails[item.contract] ? tokenDetails[item.contract].price : ''}
              image={
                (item.link && item.link.replace('ipfs://', 'https://ipfs.io/ipfs/')) ||
                '/images/empty-nft.png'
              }
              n={'ethereum'}
              contract={item.contract}
            />
          );
        })}
      </div>,
    );
    if (isMobile) {
      setShowTableEnsGrid(
        <div className="nft-list-grid ">
          {data.map((item: any, index: number) => {
            return (
              <div
                key={index}
                onClick={() => {
                  setShowTableEnsList(
                    <div className="nft-list inline-border-container">
                      <svg
                        width="0"
                        height="0"
                        viewBox="0 0 279 412"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <clipPath id="myClip">
                          <path
                            d="M16.4143 106.869V366.054L45.3183 394.943H114.532L131.575 412H258.834L276.767 394.077V309.964L261.523 294.728V198.956L279 181.466V39.4878H217.528L193.546 15.5177H71.2299L53.5363 0L0 53.5102V88.2517L16.4143 106.869Z"
                            fill="#394455"
                          />
                        </clipPath>
                      </svg>
                      <NFT
                        key={index}
                        name={item.name}
                        network={'Expiry'}
                        id={item.id}
                        wallet={item.expireDate}
                        price={tokenDetails[item.contract] ? tokenDetails[item.contract].price : ''}
                        image={
                          (item.link && item.link.replace('ipfs://', 'https://ipfs.io/ipfs/')) ||
                          '/images/empty-nft.png'
                        }
                        n={'ethereum'}
                        contract={item.contract}
                      />
                    </div>,
                  );
                  setViewType('list');
                }}
              >
                <img
                  src={
                    (item.link && item.link.replace('ipfs://', 'https://ipfs.io/ipfs/')) ||
                    '/images/empty-nft.png'
                  }
                  alt=""
                />
              </div>
            );
          })}
        </div>,
      );
    }
  };

  useEffect(() => {
    renderShowTableNft(tableDataNft);
  }, [tableDataNft]);

  useEffect(() => {
    renderShowTableEns(tableDataEns);
  }, [tableDataEns]);

  const portfolioWalletChange = (value: string) => {
    setTableWalletFilter(value);
  };

  const setDataFilter = (networks?: string[], wallet?: string) => {
    let filteredDataNft: any[] = [];
    let filteredDataEns: any[] = [...tableDataEns];
    if (networks) {
      filteredDataNft = tableDataNft.filter(item => {
        return networks ? networks.includes(item.networkKey) : true;
      });
    }
    if (wallet) {
      filteredDataNft = filteredDataNft.filter(item => {
        return wallet ? item.wallet === wallet : true;
      });
    }

    renderShowTableNft(filteredDataNft);

    if (wallet) {
      filteredDataEns = tableDataEns.filter(item => {
        return wallet ? item.wallet === wallet : true;
      });
    }

    renderShowTableEns(filteredDataEns);
  };

  useEffect(() => {
    setDataFilter(networkFilter, tableWalletFilter);
  }, [networkFilter, tableWalletFilter]);

  return (
    <div className="nft-ens">
      {loading && <div className="grayedOut" />}
      <BigMenu horizontal={true} />
      <div className="button-container mt-5">
        <div onClick={() => setSelectedType('nft')}>
          <BigButton name="NFT" type={`${selectedType === 'nft' ? 'light' : 'dark'}`} />
        </div>
        <div onClick={() => setSelectedType('ens')}>
          <BigButton name="ENS" type={`${selectedType === 'ens' ? 'light' : 'dark'}`} />
        </div>
      </div>

      {loading ? (
        <Loading inline={true} />
      ) : (
        <>
          {selectedType === 'nft' && tableDataNft.length > 0 && (
            <div className={`network-selectors-${theme}`} id="network-selectors">
              <div
                className="allFilter active"
                id="allFilterItem"
                style={{ marginBottom: '5px' }}
                onClick={(): void => {
                  const items: any = document.getElementById('network-selectors');

                  for (let i = 0; i < items.children.length; i++) {
                    items.children[i].classList.remove('active');
                  }

                  document.getElementById('allFilterItem')!.classList.add('active');
                  setDataFilter([
                    'erc20',
                    'bep20',
                    'polygon',
                    'avalanche',
                    'moonbeam',
                    'moonriver',
                  ]);
                }}
              >
                <img className="activeImage" src="icons/networks/all.png" alt="" />
                <img className="normal" src="icons/networks/all.png" alt="" />
              </div>
              {config.nft &&
                config.globalNetworks &&
                Object.keys(config.nft).map((index: any) => {
                  if (config.globalNetworks[index])
                    return (
                      <div
                        key={`${index}`}
                        data-id={index}
                        className={`${config.nft[index] === 0 ? 'disabled' : ''}`}
                      >
                        <img
                          className="activeImage"
                          onClick={(e: any): void => {
                            const items: any = document.getElementById('network-selectors');
                            const newValues: string[] = [];

                            for (let i = 0; i < items.children.length; i++) {
                              items.children[i].classList.remove('active');
                            }
                            newValues.push(e.target.parentNode.getAttribute('data-id'));
                            e.target.parentNode.classList.add('active');
                            setNetworkFilter(newValues);
                          }}
                          src={config.globalNetworks[index].icon}
                        />

                        <img
                          className="normal"
                          onClick={(e: any): void => {
                            const items: any = document.getElementById('network-selectors');
                            const newValues: string[] = [];

                            for (let i = 0; i < items.children.length; i++) {
                              items.children[i].classList.remove('active');
                            }
                            newValues.push(e.target.parentNode.getAttribute('data-id'));
                            e.target.parentNode.classList.add('active');
                            setNetworkFilter(newValues);
                          }}
                          src={config.globalNetworks[index].icon}
                        />
                      </div>
                    );
                })}
            </div>
          )}
          {(tableDataNft.length > 0 && selectedType === 'nft') ||
          (tableDataEns.length > 0 && selectedType === 'ens') ? (
            <>
              {wallets && wallets.length > 1 ? (
                <div className="table-wallet-filter">
                  <Dropdown
                    change={(value: string) => portfolioWalletChange(value)}
                    color="white"
                    size="small"
                    label="All Wallets"
                  >
                    <div key={`table-wallet-all`}>All Wallets</div>
                    {wallets &&
                      wallets.map((item: any, index: number) => {
                        return (
                          <div key={`table-wallet-${index}`} data-id={item.name}>
                            {item.name}
                          </div>
                        );
                      })}
                  </Dropdown>
                </div>
              ) : (
                <div style={{ height: '20px' }} />
              )}
            </>
          ) : (
            <div style={{ height: '20px' }} />
          )}
          {selectedType === 'nft' && tableDataNft.length == 0 && (
            <div className="no-result-nft">
              <h1>
                There is no NFT found in the portfolio.
                <br />
                You can explore and buy NFT's now.
              </h1>
              <div className="card-container">
                <Link target="_blank" to={{ pathname: 'https://opensea.io' }}>
                  <Card name="OpenSea" icon="opensea" />
                </Link>
                <Link target="_blank" to={{ pathname: 'https://rarible.com' }}>
                  <Card name="Rarible" icon="rarible" />
                </Link>
              </div>
            </div>
          )}

          {selectedType === 'ens' && tableDataEns.length == 0 && (
            <div className="no-result-ens">
              <h1>
                There is no ENS found in the portfolio.
                <br />
                You can register your own domain now.
              </h1>
              <div className="card-container">
                <Link target="_blank" to={{ pathname: 'https://ens.domain' }}>
                  <Card name="ENS" icon="ens" />
                </Link>
              </div>
            </div>
          )}

          {!loading && selectedType === 'nft' && tableDataNft && tableDataNft.length > 0 && (
            <div className={`custom-table-${theme}`}>
              {!isMobile && <div className="table-border-top mt-2" />}
              {isMobile && viewType === 'grid' && showTableNftGrid}
              {isMobile && viewType === 'list' && (
                <div className="single-item">
                  <div className="back-link" onClick={() => setViewType('grid')}>
                    <img src={`/icons/cross-${theme}.svg`} alt="" />
                  </div>
                  {showTableNftList}
                </div>
              )}
              {!isMobile && showTableNft}
              {!isMobile && <div className="table-border-bottom" />}
            </div>
          )}

          {!loading && selectedType === 'ens' && tableDataEns && tableDataEns.length > 0 && (
            <div className={`custom-table-${theme}`}>
              {!isMobile && <div className="table-border-top mt-2" />}
              {isMobile && viewType === 'grid' && showTableEnsGrid}
              {isMobile && viewType === 'list' && (
                <div className="single-item">
                  <div className="back-link" onClick={() => setViewType('grid')}>
                    <img src={`/icons/cross-${theme}.svg`} alt="" />
                  </div>
                  {showTableEnsList}
                </div>
              )}
              {!isMobile && showTableEns}
              {!isMobile && <div className="table-border-bottom" />}
            </div>
          )}
        </>
      )}
    </div>
  );
};
